import requestURLs from './urls'
import {jwtDecode} from 'jwt-decode'
import { login, logout } from 'store/auth'
import { AuthCredentials, getClientName } from 'utils/helpers'

const asyncRegister =
  ({ firstName, lastName, email, password }) =>
  async dispatch => {
    const requestURL = requestURLs.register
    debugger
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ first_name: firstName, last_name:lastName, email, password }),
    }
    const response = await fetch(requestURL, requestOptions)
    const data = await response.json()
    dispatch(login({ user: { id: 1 }, token: data.token })) // TODO -> update user object
  }

const asyncLogin =
  ({ user_name, password }) =>
  async dispatch => {

    const requestURL = requestURLs.login
    
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_name, password, realm_name : getClientName() }),
    }

    const response = await fetch(requestURL, requestOptions)
    const data = await response.json()

    if( !response.ok ) throw new Error(data.message) || 'Something went wrong';

    //console.log(data, 'data');
    const decodedToken = jwtDecode(data.access_token)
    //console.log(decodedToken, 'decodedToken');
    dispatch(login({ user: { id: decodedToken.sub, name : decodedToken.name, display_name : decodedToken.given_name, facialAuth : false }, token: data.access_token, refresh_token: data.refresh_token }))

  }

export const facialRegistration = async ( { image } ) => {
  
  const requestURL = requestURLs.facial_registration
    
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify({ image, realm_name : getClientName() }),
  }

  const response = await fetch(requestURL, requestOptions)
  const data = await response.json()

  if( !response.ok ) throw new Error(data.message) || 'Something went wrong';

  return data;

}

export const codeAuth = async ( code ) => {
    
    const { clientId, redirectUri, tokenUrl } = AuthCredentials();
      
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        code,
        redirect_uri: redirectUri,
        client_id: clientId,
      }),
    };
    console.log(code, 'code');
    const response = await fetch(tokenUrl, requestOptions)
    const data = await response.json()
  
    if( !response.ok ) throw new Error(data.message) || 'Something went wrong';
    
    const decodedToken = jwtDecode(data.access_token)
    //dispatch(login({ user: { id: 1, name : decodedToken.name }, token: data.access_token }))
    return { user: { id: decodedToken.sub, name : decodedToken.name, display_name : decodedToken.given_name, facialAuth : true }, token: data.access_token, refresh_token: data.refresh_token };
}

export const logoutFromKeycloak = async () => {

  const user = JSON.parse(localStorage.getItem('user'));

  if( !user.facialAuth ) return logoutFromBackend();
  
  const { logoutUrl, clientId } = AuthCredentials();

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      client_id: clientId,
      refresh_token: localStorage.getItem('r_token'),
    }),
  };

  const response = await fetch(logoutUrl, requestOptions);
  if (!response.ok) throw new Error('Failed to log out from Keycloak')

}

export const logoutFromBackend = async () => {
  
  const requestURL = requestURLs.logout
    
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify({ refresh_token: localStorage.getItem('r_token'), realm_name : getClientName() }),
  }

  const response = await fetch(requestURL, requestOptions)
  if (!response.ok) console.warn('Failed to log out from Service');

}

export const facialAuth = async ( { image } ) => {
  
  const requestURL = requestURLs.facial_auth
    
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ image }),
  }

  const response = await fetch(requestURL, requestOptions)
  const data = await response.json()

  if( !response.ok ) throw new Error(data.message) || 'Something went wrong';

  const decodedToken = jwtDecode(data.access_token)
  //dispatch(login({ user: { id: 1, name : decodedToken.name }, token: data.access_token }))
  return { user: { id: decodedToken.sub, name : decodedToken.name, display_name : decodedToken.display_name }, token: data.access_token };

}

const asyncLogout = () => async dispatch => {
  // TODO -> call logout API here if needed
  return dispatch(logout())
}

export { asyncRegister, asyncLogin, asyncLogout }
